import React, { FC } from 'react'
import { EditorTheme } from '../../templateEditor.theme'
import { TemplateElement } from '../../templateEditor.types'
import { TemplateEditorInlineEditApi } from '../../hooks/document/useTemplateEditorInlineEdit'
import { toDisplaySize } from '../../templateEditor.utils'
import { TemplateEditorListView } from './TemplateEditorListView'
import { TemplateEditorMediaView } from './TemplateEditorMediaView'
import { TemplateEditorShapeView } from './TemplateEditorShapeView'
import { TemplateEditorTableView } from './TemplateEditorTableView'
import { TemplateEditorTextView } from './TemplateEditorTextView'

type TemplateEditorElementViewProps = {
    element: TemplateElement
    theme: EditorTheme
    inlineEdit: TemplateEditorInlineEditApi
}

export const TemplateEditorElementView: FC<TemplateEditorElementViewProps> = ({ element, theme, inlineEdit }) => {
    const scale = theme.displayScale

    switch (element.type) {
        case 'shape':
            return <TemplateEditorShapeView element={element} scale={scale} theme={theme} />
        case 'text':
            return <TemplateEditorTextView element={element} scale={scale} inlineEdit={inlineEdit} />
        case 'image':
        case 'video':
            return <TemplateEditorMediaView element={element} scale={scale} />
        case 'list':
            return <TemplateEditorListView element={element} scale={scale} inlineEdit={inlineEdit} />
        case 'table':
            return <TemplateEditorTableView element={element} scale={scale} inlineEdit={inlineEdit} />
        case 'group':
            return null
        default:
            return null
    }
}

export const elementDisplayStyle = (element: TemplateElement, scale: number): React.CSSProperties => ({
    left: toDisplaySize(element.x, scale),
    top: toDisplaySize(element.y, scale),
    width: toDisplaySize(element.w, scale),
    height: toDisplaySize(element.h, scale),
    ...(element.rotate
        ? {
              transform: `rotate(${element.rotate}deg)`,
              transformOrigin: 'center center',
          }
        : null),
})
